import React from 'react';
import { useParams } from 'react-router';
import i18n from '../../utilities/i18n';
import AccountHeader from './accountComponents/AccountHeader';
import { useQuery } from '@tanstack/react-query';
import {
  Highlight,
  IconBannersWarning,
  LoadingSpinner,
  VStack,
} from '@adc/parallax-component-library';
import { accountQueryOptions } from '../../queryOptions';

import { useErrorMessageOnEntityView } from '../../hooks/useErrorMessageOnEntityView';

export function Account() {
  const { accountKey } = useParams();

  const account = useQuery(accountQueryOptions({ key: accountKey }));

  const errorMessage = useErrorMessageOnEntityView(
    account.error,
    'Page_Account.load_error',
  );

  return (
    <VStack gap={'$4'} height={'100%'}>
      {account.isPending ? (
        <VStack alignItems="center" justifyContent="center" flexGrow={1}>
          <LoadingSpinner testID="account-loading-spinner" />
        </VStack>
      ) : null}

      {account.isError ? (
        <Highlight
          variant="danger"
          iconStart={
            <IconBannersWarning
              color="$neutral.0"
              accentColor="$support.danger.default"
            />
          }
          title={i18n.t('Page_Account.load_error_title')}
          body={i18n.t(errorMessage)}
          testID="account-error-banner"
        />
      ) : null}

      {account.isSuccess ? <AccountHeader account={account.data} /> : null}
    </VStack>
  );
}
